export default __webpack_public_path__ + "static/media/02.50c31406.jpg";